export class Costanti {
  public static INTERNAL_ID = 'SIVG_internalId';
  public static DATA_NOT_FOUND_ERROR = `Nessun dato da mostrare per questa sezione`;
  public static SECTION_DATA_NOT_FOUND_ERROR = `Nessun dato da mostrare per la sezione`;
}
